// Business Workflows client — one call for the whole engine surface.
// The backend (/api/wf/engine) enforces auth + an action allowlist and stamps
// the caller's identity server-side, then delegates to the per-project
// process engine (cortex.workflows.api on the paired Flow fork).
import { fetchData } from '../fetchapi/fetchapi';

export async function wfEngine(action, params = {}) {
  return fetchData('wf/engine', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, params }),
  });
}
